export function DevicesPage() {
  return (
    <div>
      <h1 className="text-3xl font-bold mb-4">Devices</h1>
      <p className="text-gray-600">Device management coming soon...</p>
    </div>
  )
}
